import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { loader } from "../../redux/type";
import { panCardSendOtp } from "../../Services/postServices";
import { updateCitizenProfile, verifyMobileOtp } from "../../Services/getServices";
import OtpInput from "react-otp-input";
import { sendOtpMobile } from "../../Services/getServices";

const Bhoomi = () => {
    const dispatch = useDispatch();
   const mobNum = localStorage.getItem("moblie");
   const userData = JSON.parse(localStorage.getItem("user"));
   const urL = useLocation().state?.url_Link;
   const domainCode = useLocation().state?.doCode;
   const id = userData?.user?.id;
 
   
    const token=localStorage.getItem("token");
    const url2 = `${urL}?token=${token}`;
   
 
   var [tit, setTit] = useState("");
   var [firstName, setFirstName] = useState("");
   var [middleName, setMiddleName] = useState("");
   var [lastName, setLastName] = useState("");
   var [fatherName, setFatherName] = useState("");
   var [aadhaarNo, setAadhaarNo] = useState("");
   var [mobileNo, setMobileNo] = useState("");
   var [panNo, setPanNo] = useState("");
   var [email, setEmail] = useState("");
   var [gender, setGender] = useState("");
   var [dob, setDob] = useState("");
 
   const [otp, setOtp] = useState("");
 
 
  const [mobno, setMobno] = useState("");
  const [showOtpBtn, setShowOtpBtn] = useState("0");
   const [showMessage,setShowMessage]=useState("0");
   function checkPancard(){
 
     let req={
       // "pan": "ALUPY0561F",
       "pan":panNo,
     "domainCode": domainCode
     }
     dispatch({ type: loader.startLoader });
 
     panCardSendOtp(req,(res)=>{
       dispatch({ type: loader.stopLoader });
 
       if(res?.data?.status){
        
         setMobno(res?.data?.result[0]?.mobileNumber);
       
           setShowOtpBtn("2");
         toast.success(res?.data?.message);
 
         
       }
       else{
         toast.error(res?.data?.message);
       }
 
     })
 
   }
 
 
   const [secondsLeft, setSecondsLeft] = useState(180);
  const [timerStarted, setTimerStarted] = useState(false);
  const [showFinalButton, setShowFinalButton] = useState(false);

  useEffect(() => {
    let interval;

    if (timerStarted) {
      interval = setInterval(() => {
        setSecondsLeft((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            setShowFinalButton(true);
            setTimerStarted(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [timerStarted]);

  const formatTime = (secs) => {
    const minutes = Math.floor(secs / 60);
    const seconds = secs % 60;
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
      2,
      "0"
    )}`;
  };
   const [showBtn, setShowBtn] = useState("0");
   function getMoblieOtp() {
     dispatch({ type: loader.startLoader });
 
     sendOtpMobile(mobno, (res) => {
       dispatch({ type: loader.stopLoader });
       if (res?.data?.status) {
        setTimerStarted(true);
        setShowFinalButton(false);
        setSecondsLeft(180);
        
         setShowBtn("2");
 
         // toast.success("OTP has been sent on register mobile number")
         toast.success(res?.data?.message);
       } else {
         //  toast.error("Please check your mobile number")
         toast.error(res?.data?.message);
       }
     });
   }
 
   const [redirectBtn, setRedirectBtn] = useState("0");
   function verifyOtp() {
     dispatch({ type: loader.startLoader });
     verifyMobileOtp(mobno, otp, (res) => {
       dispatch({ type: loader.stopLoader });
      
       if (res?.data?.status) {
         setRedirectBtn("2");
         toast.success(res?.data?.message);
       } else {
         toast.error(res?.data?.message);
       }
     });
   }
   function maskMobile(number) {
     if (!number || number.length < 10) {
       return number;
     }
 
     return number.replace(/.(?=.{4})/g,'*');
   }
 
 function saveUser(){
 
   let req={
     "userId":id,
     "domainCode": domainCode,
     "panCard": panNo
     
   }
    dispatch({ type: loader.startLoader });
    updateCitizenProfile(req, (res) => {
         dispatch({ type: loader.stopLoader });
         if (res?.data?.status) {
           toast.success(res?.data?.message);
          
          
         } else {
           toast.error(res?.data?.message)
          
         }
       });
 
 
 }
 
  return (
    <>
     <div className="card shadow myprofileCard ">
        <div className="card-body overFlow p-md-3">
          <h4 className="h2_heading">Awaas</h4>
          <div className="row  ">
           

            <div className="col-4">
              <div className="form-outline mb-3">
                <label className="form-label" for="id">
                  PAN Card Number:
                </label>
                <input
                  type="mobile"
                    onChange={(e) => setPanNo(e.target.value)}
                  className="form-control"
                  placeholder="Enter here"
                />
              </div>
            </div>
           

            <div className="col-4 " style={{ marginTop: "2rem" }}>
              <button className="btn btn-primary" onClick={checkPancard}
             disabled ={showOtpBtn==="0"?false:true}
              >
                Verify Pancard
              </button>
            </div>

          



            {showOtpBtn === "2" ? (
              <>
                <p>
                 
                 <b> Mobile Number:-  ({maskMobile(mobno)}) is registered against this PanCard. Kindly verify with otp</b>
                  
                </p>

                <div className="col-4">
                  <div className="form-outline mb-3">
                    <label className="form-label" for="id">
                      Mobile Number:
                    </label>
                    <input
                      type="mobile"
                      value= {maskMobile(mobno)}
                      // onChange={(e) => setConsumerId(e.target.value)}
                      className="form-control"
                      placeholder="Enter here"
                      disabled
                    />
                  </div>
                </div>

                {showBtn === "0" ? (
                  <>
                    <div className="col-4 " style={{ marginTop: "2rem" }}>
                      <button
                        className="btn btn-primary"
                        onClick={getMoblieOtp}
                      >
                        Verify With OTP
                      </button>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="col-4">
                      <div className="form-outline mb-3">
                        <label className="form-label" for="Enter Aadhaar">
                          Enter OTP:
                        </label>
                        {/* <p>Otp has been sent to your mobile number.</p> */}

                        <div class="otp-container">
                          <OtpInput
                            value={otp}
                            onChange={setOtp}
                            numInputs={6}
                            renderSeparator={<span>-</span>}
                            renderInput={(props) => (
                              <input class="otp-input " {...props} />
                            )}
                          />
                        </div>
                      </div>
                    </div>


                    <div className="col-4 " style={{ marginTop: "2rem" }}>
                          {timerStarted && !showFinalButton && (
                            <b>Resend OTP after: {formatTime(secondsLeft)}</b>
                          )}

                          {showFinalButton && (
                            <button
                              type="button "
                              className="btn btn-primary w-100 mt-2"
                              onClick={getMoblieOtp}
                            >
                              Resend OTP
                            </button>
                          )}
                        </div>

                    <div className="col-4 " 
                    // style={{ marginTop: "2rem" }}
                    disabled={redirectBtn==="2"?true:false}
                    >
                      <button className="btn btn-primary" onClick={verifyOtp}>
                        Submit
                      </button>
                    </div>
                  </>
                )}
              </>
            ) : (
              <></>
            )}


{redirectBtn==="2"?<>
  <div className="col-4 " style={{marginTop:"2rem"}}>
            <a
           
                                href={url2}
                                target="_blank"
                                alt="Link Not working"
                              >
                               
                                <button className="btn btn-primary" onClick={saveUser}>
                                  Clik here to open
                                </button>
                               
                              </a>
                              </div>
</>:<></>}


           


          </div>
        </div>
      </div>
    </>
  );
};
export default Bhoomi;
